module.exports = __webpack_public_path__ + "static/img/bg.590046d3.jpg";